import FilterModel from 'app/components/FilterModel';
import PageLoader from 'app/components/PageLoader';
import PaginatedTable from 'app/components/table/PaginationTable';
import { notificationTableHeader } from 'app/constants/table-header-constants';
import useNotificationManagement from './useNotificationManagement';

const NotificationManagement = () => {
  const {
    values,
    setValues,
    totalNumber,
    sectionObj,
    filteredData,
    handleDelete,
    handleEdit,
    pageLoading,
    dataPerPage,
    pageCount,
    setIsFilterOpen,
    isFilterOpen,
    handleSubmit,
    resetfilterModel,
    handleFilterCancel,
    fetchNotificationData,
    isdeleteFiltering,
  } = useNotificationManagement();

  return (
    <>
      <div className='cms-content__container'>
        <PaginatedTable
          fulldata={filteredData}
          sectionObj={sectionObj}
          columns={notificationTableHeader}
          data={filteredData}
          dataPerPage={dataPerPage}
          pageCountNumber={pageCount}
          totalNumber={totalNumber}
          handleDelete={handleDelete}
          handleEdit={handleEdit}
          pageLoading={pageLoading}
          fetchData={fetchNotificationData}
          isdeleteFiltering={isdeleteFiltering}
        />
        {isFilterOpen && (
          <FilterModel
            isFilterOpen={isFilterOpen}
            setIsFilterOpen={setIsFilterOpen}
            onSubmit={handleSubmit}
            onCancel={handleFilterCancel}
            values={values}
            setValues={setValues}
            resetfilter={resetfilterModel}
          >
            <>
              <div className='offcanvas-item'>
                <label>Name:</label>
                <input
                  type='text'
                  value={values?.name}
                  onChange={(e) =>
                    setValues({ ...values, name: e.target.value })
                  }
                />
              </div>
              <div className='offcanvas-item'>
                <label>Title:</label>
                <input
                  type='text'
                  value={values?.title}
                  onChange={(e) =>
                    setValues({ ...values, title: e.target.value })
                  }
                />
              </div>
            </>
          </FilterModel>
        )}
      </div>

      {pageLoading === true && <PageLoader pageLoading={pageLoading} />}
    </>
  );
};

export default NotificationManagement;
